import { BlockContainer, ProductListComponent, ProductListComponentProps } from '@components';

// TYPES
//-------
export type ProductListBlockProps = ProductListComponentProps;

// COMPONENTS
//------------
export const ProductListBlock = (props: ProductListBlockProps) => {
  return (
    <BlockContainer>
      <ProductListComponent {...props} />
    </BlockContainer>
  );
};
